import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

import { CAFSteps } from '../CAFSteps'
import { StyledContentWrapper } from './styles'
import { useTranslation } from '../../../context/translationProvider'
import { CAF_MESSAGE_CODES, FIVE_SECONDS, SOCIAL_SIGNIN_TYPES } from '../../../utils/constants'
import { getLivenessStatus } from '../../../adapters/payments'
import { toast } from '../../atoms'
import { useSocialSignIn } from '../../../hooks/useSocialSignIn'

const Login2faSSOContent = (props) => {
  const { livenessUrl, onboardingId, idToken, onFail, onSignInError } = props
  const { translate } = useTranslation()
  const { socialSignIn } = useSocialSignIn()

  const [verificationStarted, setVerificationStarted] = useState(false)
  const [isWaitingVerification, setIsWaitingVerification] = useState(false)
  const [repeatingTimeoutId, setRepeatingTimeoutId] = useState()
  const timeoutIdRef = useRef(repeatingTimeoutId)
  timeoutIdRef.current = repeatingTimeoutId

  const checkIsVerified = async () => {
    const response = await getLivenessStatus(onboardingId)

    if (!response.ok) {
      toast.error(response.error.message)
      clearTimeout(timeoutIdRef.current)
      onFail()
      return
    }

    if (response.data.status === 'APPROVED') {
      clearTimeout(timeoutIdRef.current)
      await socialSignIn({
        code: idToken,
        type: SOCIAL_SIGNIN_TYPES.GOOGLE,
        isIdToken: true,
        onError: (response) => {
          onSignInError(response)
          onFail()
          return
        },
      })

      return
    }

    const newTimeoutId = setTimeout(() => checkIsVerified(), FIVE_SECONDS)
    setRepeatingTimeoutId(newTimeoutId)
  }

  const onCloseCAFIFrame = (status) => {
    if(status === CAF_MESSAGE_CODES.INVALID) {
      return
    }

    checkIsVerified()
  }

  return (
      <StyledContentWrapper>
        <CAFSteps
        isBankAccountProcess
        cafIframeUrl={livenessUrl}
        isWaitingVerification={isWaitingVerification}
        forceWaiting
        closeCafIFrame={onCloseCAFIFrame}
        setIsWaitingVerification={setIsWaitingVerification}
        idVerificationStarted={verificationStarted}
        setIdVerificationStarted={setVerificationStarted}
        startAltDescription={translate(
          '2fa.liveness.startDescription'
        )}
        startAltTitle={translate(
          '2fa.liveness.startTitle'
        )}
        waitingAltTitle={translate(
          '2fa.liveness.waitingTitle'
        )}
        waitingAltDescription={translate(
          '2fa.liveness.waitingDescription'
        )}
      />
    </StyledContentWrapper>
  )
}

Login2faSSOContent.propTypes = {
  livenessUrl: PropTypes.string,
  onboardingId: PropTypes.string,
  idToken: PropTypes.string,
  onFail: PropTypes.func,
  onSignInError: PropTypes.func,
}

export { Login2faSSOContent }
